import { FC } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * Error Fallback Component
 *
 * Displays a user-friendly error page when an unhandled error occurs.
 * Used with react-error-boundary's ErrorBoundary component.
 */
const ErrorFallback: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                padding: 3,
                backgroundColor: '#f5f5f5',
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    padding: 4,
                    maxWidth: 600,
                    textAlign: 'center',
                }}
            >
                <ErrorOutlineIcon
                    color="error"
                    sx={{ fontSize: 80, marginBottom: 2 }}
                />
                <Typography variant="h4" gutterBottom>
                    Oops! Something went wrong
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                    {error instanceof Error ? error.message : 'An unexpected error occurred'}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={resetErrorBoundary}
                    sx={{ marginTop: 2 }}
                >
                    Try Again
                </Button>
            </Paper>
        </Box>
    );
};

export default ErrorFallback;

